import * as types from '../constants';

export const initReportListState = () => ({
  type: types.INIT_REPORT_LIST_STATE,
});

export const setReportList = reportList => ({
  type: types.SET_REPORT_LIST,
  payload: reportList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_REPORT_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_REPORT_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_REPORT_FILTER_ITEM,
  payload: filterItem
});